import {
    FETCH_THEMES_IDS,
    FETCH_THEMES_IDS_DATA,
    FETCH_THEMES_IDS_ERROR,
    FETCH_THEME,
    FETCH_THEME_DATA,
    FETCH_THEME_ERROR,
    CLONE_THEME,
    CLONE_THEME_SUCCESS,
    CLONE_THEME_ERROR,
    EDIT_THEME,
    EDIT_THEME_SUCCESS,
    EDIT_THEME_ERROR,
    DELETE_THEME,
    DELETE_THEME_SUCCESS,
    DELETE_THEME_ERROR,
    FETCH_THEME_SCHEMA,
    FETCH_THEME_SCHEMA_SUCCESS,
    FETCH_THEME_SCHEMA_ERROR,
} from './constants';

export const fetchThemesIds = (appId) => ({
    type: FETCH_THEMES_IDS,
    payload: { appId },
});

export const fetchThemesIdsData = (data) => ({
    type: FETCH_THEMES_IDS_DATA,
    payload: { data },
});

export const fetchThemesIdsError = () => ({
    type: FETCH_THEMES_IDS_ERROR,
});

export const fetchTheme = (appId, themeId) => ({
    type: FETCH_THEME,
    payload: { appId, themeId },
});

export const fetchThemeData = (themeId, data) => ({
    type: FETCH_THEME_DATA,
    payload: { themeId, data },
});

export const fetchThemeError = () => ({
    type: FETCH_THEME_ERROR,
});

export const cloneTheme = (sourceTheme, message) => ({
    type: CLONE_THEME,
    payload: { sourceTheme },
    message,
});

export const cloneThemeSuccess = (payload) => ({
    type: CLONE_THEME_SUCCESS,
    payload,
});

export const cloneThemeError = (payload) => ({
    type: CLONE_THEME_ERROR,
    payload,
});

export const editTheme = (themeId, data, message) => ({
    type: EDIT_THEME,
    payload: { themeId, data },
    message,
});

export const editThemeSuccess = (payload) => ({
    type: EDIT_THEME_SUCCESS,
    payload,
});

export const editThemeError = () => ({
    type: EDIT_THEME_ERROR,
});

export const deleteTheme = (themeId, message) => ({
    type: DELETE_THEME,
    payload: themeId,
    message,
});

export const deleteThemeSuccess = (payload) => ({
    type: DELETE_THEME_SUCCESS,
    payload,
});

export const deleteThemeError = () => ({
    type: DELETE_THEME_ERROR,
});

export const fetchThemeSchema = (themeId) => ({
    type: FETCH_THEME_SCHEMA,
    payload: themeId,
});

export const fetchThemeSchemaSuccess = (payload) => ({
    type: FETCH_THEME_SCHEMA_SUCCESS,
    payload,
});

export const fetchThemeSchemaError = () => ({
    type: FETCH_THEME_SCHEMA_ERROR,
});
